import ChatButton from "@/chatbot-library/ChatButton"
import ChatCalendar from "../chatbot-library/ChatCalendar"
import ChatCheckboxes from "@/chatbot-library/ChatCheckboxes"
import ChatInput from "@/chatbot-library/ChatInput"
import ChatRadios from "@/chatbot-library/ChatRadios"
import ChatText from "@/chatbot-library/ChatText"
import InputValidation from "@/chatbot-library/InputValidation"
import moment from "moment"
import store from "@/store"

let chat = [
  new ChatText("welcome",
    {
      content: "Vous souhaitez prendre rendez-vous pour l'entretien de votre véhicule ? Rien de plus facile.",
      next: "best-slot",
      callback: () => store.commit("appointmentBooking/flow/setStartedAt", new Date())
    },
    { delay: 0 }
  ),

  new ChatText("best-slot", () =>
  {
    return store
      .dispatch("appointmentBooking/flow/loadAvailabilities")
      .then(slots => {
        if (!slots || !Object.keys(slots).length) {
          throw Error
        }

        return {
          content: "Commençons par chercher ensemble le meilleur créneau.",
          next: "next-day-slot"
        }
      })
      .catch(() => {
        return { content: "Aucun créneau disponible pour le moment." }
      })
  }),

  new ChatText("next-day-slot", () =>
  {
    return {
      content: `Quel jour souhaitez-vous déposer votre véhicule ? Notre prochaine disponibilité est le ${moment(store.getters["appointmentBooking/flow/getFirstAvailableDate"]).format("dddd DD MMMM YYYY")}.`,
      actions: [
        new ChatCalendar(
          {
            label: "Continuer",
            dates: store.getters["appointmentBooking/flow/getAvailableDates"]
          },
          {
            next: "next-time-slot",
            callback: value => store.commit("appointmentBooking/flow/setSelectedDate", value)
          }
        )
      ]
    }
  }),

  new ChatText("next-time-slot", () =>
  {
    let selectedDate = store.state.appointmentBooking.flow.selectedDate
    let times = store.getters["appointmentBooking/flow/getAvailableTimes"](selectedDate)
    times = times.map(elem => {
      let date = moment(elem, "HH:mm")
      return {
        id: elem,
        label: date.format("HH[h]mm")
      }
    })
    return {
      content: "À quelle heure ?",
      actions: [
        new ChatRadios(
          {
            label: "Continuer",
            options: times
          },
          {
            next: "duly-noted",
            callback: value => store.commit("appointmentBooking/flow/setSelectedTime", value)
          }
        ),
        new ChatButton(
          { label: "Choisir une autre date", },
          { next: "next-day-slot" }
        )
      ]
    }
  }),

  new ChatText("duly-noted",
    {
      content: "C'est noté !",
      next: "service-selection"
    }
  ),

  new ChatText("service-selection", () =>
  {
    return store
      .dispatch("appointmentBooking/flow/loadAvailableReasons")
      .then(reasons => {
        reasons = reasons.map(group => {
          return {
            label: group.name,
            id: group.id,
            options: group.actions.map(action => {
              return {
                label: action.name,
                id: action.id,
                checked: false
              }
            })
          }
        })

        return {
          content: "Quelle(s) prestation(s) souhaitez-vous réaliser ?",
          actions: [
            new ChatCheckboxes(
              {
                label: "Valider",
                options: reasons,
                hasGroups: true,
                isAtLeastOneCheckboxeRequired: true
              },
              {
                next: "almost-finished",
                callback: value => store.commit("appointmentBooking/flow/setSelectedReasons", value)
              }
            )
          ]
        }
      })
      .catch(() => {})
  }),

  new ChatText("almost-finished",
    {
      content: "Excellent. Pour terminer, donnez à notre équipe le moyen de confirmer votre rendez-vous.",
      next: "ask-plate"
    }
  ),

  new ChatText("ask-plate",
    {
      content: "Quelle est l'immatriculation de votre véhicule ?",
      actions: [
        new ChatInput(
          {
            label: "Voici !",
            placeholder: "Votre plaque d'immatriculation",
            mask: InputValidation.plate.mask,
            validator: InputValidation.plate.validator,
            transform: InputValidation.plate.transform
          },
          {
            next: "ask-firstname",
            callback: value => store.commit("appointmentBooking/flow/setPlateNumber", value.replace(/\s/g, "")),
            isEditable: true
          }
        )
      ]
    }
  ),

  new ChatText("ask-firstname",
    {
      content: "Quelle est votre prénom ?",
      actions: [
        new ChatInput(
          {
            label: "Confirmer",
            placeholder: "Votre prénom",
            mask: InputValidation.name.mask,
            validator: InputValidation.name.validator
          },
          {
            next: "ask-lastname",
            callback: value => store.commit("appointmentBooking/flow/setFirstname", value),
            isEditable: true
          }
        )
      ]
    }
  ),

  new ChatText("ask-lastname",
    {
      content: "Quelle est votre nom ?",
      actions: [
        new ChatInput(
          {
            label: "Confirmer",
            placeholder: "Votre nom",
            mask: InputValidation.name.mask,
            validator: InputValidation.name.validator
          },
          {
            next: "ask-email",
            callback: value => store.commit("appointmentBooking/flow/setLastname", value),
            isEditable: true
          }
        )
      ]
    }
  ),

  new ChatText("ask-email",
    {
      content: "Quelle est votre adresse mail ?",
      actions: [
        new ChatInput(
          {
            label: "Confirmer",
            placeholder: "Votre adresse mail",
            mask: InputValidation.email.mask,
            validator: InputValidation.email.validator
          },
          {
            next: "ask-phone-number",
            callback: value => store.commit("appointmentBooking/flow/setEmail", value),
            isEditable: true
          }
        )
      ]
    }
  ),

  new ChatText("ask-phone-number",
    {
      content: "Quel est votre numéro de téléphone ?",
      actions: [
        new ChatInput(
          {
            label: "Confirmer",
            placeholder: "Votre numéro",
            mask: InputValidation.phoneNumber.mask,
            validator: InputValidation.phoneNumber.validator
          },
          {
            next: "thank-you",
            callback: value => store.commit("appointmentBooking/flow/setPhoneNumber", value.replace(/\s/g, "")),
            isEditable: true
          }
        )
      ]
    }
  ),

  new ChatText("thank-you", () => {
    return store
      .dispatch("appointmentBooking/flow/storeAppointment")
      .then(() => {
        return {
          content: "Merci pour toutes ces informations !",
          next: "confirm-appointment"
        }
      })
      .catch(() => {
        return { content: "Impossible  d'enregistrer votre rendez-vous." }
      })
  }),

  new ChatText("confirm-appointment",
    {
      content: "Vous allez recevoir une confirmation de votre rendez-vous par email.",
      next: "goodbye"
    }
  ),

  new ChatText("goodbye",
    { content: "À bientôt !" }
  )
]

export default {
  entry: "welcome",
  chat
}
